import script from "./YFHWPage16.vue?vue&type=script&setup=true&lang=js"
export * from "./YFHWPage16.vue?vue&type=script&setup=true&lang=js"

import "./YFHWPage16.vue?vue&type=style&index=0&id=2dd3ed5a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd3ed5a"]])

export default __exports__